/**
 * <DocumentsVault> — global Documents Vault page at /manager/documents.
 *
 * Shows every document across all properties and all tenants. The upload
 * action lives on per-property and per-tenant screens (since uploads need
 * a scope target). From here owners can search, filter, download, and
 * delete documents — useful as a one-stop audit / compliance view.
 */
import React from 'react';
import { FolderOpen } from 'lucide-react';
import DocumentsList from './DocumentsList';
import PageMeta from '../PageMeta';

const DocumentsVault = () => {
  return (
    <div className="p-4 sm:p-6 lg:p-8" data-testid="documents-vault-page">
      <PageMeta title="Documents Vault" noindex />

      <div className="mb-6 flex items-start gap-3">
        <div className="w-11 h-11 rounded-xl bg-blue-50 ring-1 ring-blue-100 flex items-center justify-center flex-shrink-0">
          <FolderOpen className="text-blue-700" size={20} />
        </div>
        <div>
          <h1 className="text-3xl font-bold text-gray-900 tracking-tight">Documents Vault</h1>
          <p className="text-gray-500 mt-1">
            All your KYC, agreements, FSSAI, fire NOC, and tenant documents in one secure place.
            Sensitive files (Aadhaar, PAN) are encrypted at rest.
          </p>
          <p className="text-xs text-gray-400 mt-1.5">
            Upload from a tenant profile or property details page to add new documents.
          </p>
        </div>
      </div>

      <DocumentsList scope="all" hideHeader />
    </div>
  );
};

export default DocumentsVault;
